import React from 'react';
import { Box, Text, Button } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { useAtom } from 'jotai';
import { ChevronRight } from 'wix-ui-icons-common';
import { dataHooks } from '../../datahooks';
import { userRejectedPaymentsAtom } from '../../atoms';
import { usePaymentAcceptance } from '../../hooks/usePaymentAcceptance';
import { useStoreName } from '../../../../store/appStore';
import { AcceptTerms } from '../../components/AcceptPayments/AcceptTerms';
import { CardLayout } from '../../../../components/layouts/CardLayout';

interface StoreNameSideProps {
  onLaunch: () => void;
}

export function StoreNameSide({ onLaunch }: StoreNameSideProps) {
  const { t } = useTranslation();
  const storeName = useStoreName();
  const [userRejectedPayments, setUserRejectedPayments] = useAtom(userRejectedPaymentsAtom);

  const { isPaymentsAccepted, isShowAcceptPayments } = usePaymentAcceptance();

  function handleAcceptPaymentsChange() {
    setUserRejectedPayments(!userRejectedPayments);
  }

  return (
    <Box direction="vertical" gap={4} dataHook={dataHooks.StoreNameSideContent}>
      <CardLayout>
        <AcceptTerms
          onCheckboxChange={handleAcceptPaymentsChange}
          isAccepted={isPaymentsAccepted}
          isShowPayments={isShowAcceptPayments}
        />
      </CardLayout>

      <CardLayout gap={3}>
        <Text weight="bold">{t('store_name.cta.header')}</Text>

        <Text>
          {storeName ? t('store_name.cta.subtitle', { storeName }) : t('store_name.cta.subtitle_placeholder')}
        </Text>
        <Button disabled={!storeName} onClick={onLaunch} size="large" fullWidth suffixIcon={<ChevronRight />}>
          {t('store_name.cta.button')}
        </Button>
      </CardLayout>
    </Box>
  );
}
